// extracted by mini-css-extract-plugin
export default {"deliveriesBlock":"Deliveries_deliveriesBlock__gop14","container":"Deliveries_container__GzPzs","deliveries":"Deliveries_deliveries__OWC+S","title":"Deliveries_title__DkcXW"};